import React from "react"
import { Link, graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.supersheet.post
    const html = post.content.html
    const siteTitle = this.props.data.supersheet.site.title
    const authors = post.authors
    const { previous, next } = this.props.pageContext
    
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.title}
          description={post.content.description || post.excerpt}
        />
        <article>
          <header>
            <h1 class="mt-5 mb-0">
              {post.title}
            </h1>
            <p class="mb-5 block">
              {post.published_at}
            </p>
          </header>
          <section dangerouslySetInnerHTML={{ __html: html }} />
          <hr class="mb-5"/>
          <footer>
            {authors.map(author => {
              return (
                <Bio author={author}/>
              )
            })}
          </footer>
        </article>

        <nav>
          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.slug} rel="prev">
                  ← {previous.title}
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.slug} rel="next">
                  {next.title} →
                </Link>
              )}
            </li>
          </ul>
        </nav>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
query BlogPostBySlug($slug: String!) {
  supersheet {
    site: findOneSite {
      title
    }
    post: findOnePosts(
      filter: { slug: { eq: $slug } }
    ) {
      id
      title
      content {
        description
        html
      }
      published_at(
        formatString: "DDDD"
        zone: "America/Los_Angeles"
      )
      authors {
        name
        email
        avatar {
          src
        }
        bio
      }
    }
  }
}`